"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Incoming = void 0;
var Incoming;
(function (Incoming) {
    Incoming["RoomPlayerIsReady"] = "RoomPlayerIsReady";
    Incoming["RoomPlayerCanPutCard"] = "RoomPlayerCanPutCard";
    Incoming["RoomPlayerPutCard"] = "RoomPlayerPutCard";
    Incoming["RoomPlayerSkipTurn"] = "RoomPlayerSkipTurn";
    Incoming["RoomPlayerChooseSwapTarget"] = "RoomPlayerChooseSwapTarget";
    Incoming["RoomPlayerBackInGame"] = "RoomPlayerBackInGame";
    Incoming["PlayerChangeLanguage"] = "PlayerChangeLanguage";
    Incoming["PlayerChangeAvatar"] = "PlayerChangeAvatar";
    Incoming["PlayerChangeFlag"] = "PlayerChangeFlag";
    Incoming["PlayerChangeUsername"] = "PlayerChangeUsername";
    Incoming["PlayerGameRequest"] = "PlayerGameRequest";
    Incoming["PlayerLeaveLobby"] = "PlayerLeaveLobby";
    Incoming["PlayerLeaveRoom"] = "PlayerLeaveRoom";
    Incoming["PlayerCheckLobby"] = "PlayerCheckLobby";
    Incoming["PlayerCheckRoom"] = "PlayerCheckRoom";
    Incoming["PlayerConfirmBackup"] = "PlayerConfirmBackup";
    Incoming["JoinAsSpectator"] = "JoinAsSpectator";
    Incoming["LeaveSpectator"] = "LeaveSpectator";
    Incoming["ToggleLobbyPlayerState"] = "ToggleLobbyPlayerState";
    Incoming["ToggleHostStart"] = "ToggleHostStart";
    Incoming["LobbyUpdateRules"] = "LobbyUpdateRules";
    Incoming["RoomPlayerEmote"] = "RoomPlayerEmote";
    Incoming["RoomChatMessage"] = "RoomChatMessage";
    Incoming["RoomChatTyping"] = "RoomChatTyping";
    Incoming["PlayerGetLeaderboard"] = "PlayerGetLeaderboard";
    Incoming["PlayerSearch"] = "PlayerSearch";
    Incoming["RecoveryStart"] = "RecoveryStart";
    Incoming["RecoveryLink"] = "RecoveryLink";
    Incoming["RecoveryRestore"] = "RecoveryRestore";
    Incoming["RecoveryChallenge"] = "RecoveryChallenge";
})(Incoming || (exports.Incoming = Incoming = {}));
;
